import { render, staticRenderFns } from "./setStorePurchaseDisplayDialog.vue?vue&type=template&id=5315beba&"
import script from "./setStorePurchaseDisplayDialog.vue?vue&type=script&lang=ts&"
export * from "./setStorePurchaseDisplayDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports